<div autosize autoFocus [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top',
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder,
  }" [dir]="options.dir!">
  <!-- ============================================================== -->
  <!-- VerticalHeader -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
  <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
    (toggleMobileNav)="sidenav.toggle()"></app-header>
  }

  <mat-sidenav-container class="mainWrapper">
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->

    @if (!options.horizontal) {
    <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="
        options.navPos === 'side' &&
        options.sidenavOpened &&
        !isOver 
      " (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav []"
      [ngClass]="{'sidebarNavWidth': !options.sidenavCollapsed && options.navPos !== 'top'}">
      <ng-scrollbar class="position-relative mini-scroll" style="height: calc(91vh)">
        <mat-nav-list class="sidebar-list">
          @for (item of currentNavItems; track item; let i = $index) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()" [expanded]="i === indexOnExpand"
            (expandEmitter)="setIndexItemOnExpand(i)">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
    }

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper">
      <main class="pageWrapper" [ngClass]="{ maxWidth: options.boxed }">
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>

      </main>

      <div class="main-footer d-flex justify-content-center align-items-end f-s-12 p-16">
        <span class="m-r-4">
          {{ version }}
        </span>

        <span class="m-x-4">
          powered by
        </span>

        <a class="intrapresa-sign" target="_blank" href="https://www.intrapresa-it.it/"></a>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>